module.exports = __webpack_public_path__ + "static/media/nb.df61ee2c.png";